export function preventIosInputZoom() {
  const isIos =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1)

  if (!isIos) return

  document
    .querySelector('meta[name=viewport]')
    ?.setAttribute(
      'content',
      'width=device-width, initial-scale=1, maximum-scale=1',
    )
}
